import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import { pieChartProps } from './BasicPieChart'

ChartJS.register(ArcElement, Tooltip, Legend)

const DoughnutChart = (props: pieChartProps) => {
    let datasets = props.datasets.map((dataset) => {
        return {
            label: dataset.name,
            data: dataset.data,
            ...dataset.dataConfig,
        }
    })
    return (
        <Doughnut
            options={props.options}
            data={{
                labels: props.labels,
                datasets: [...datasets],
            }}
        />
    )
}
export default DoughnutChart
